import script from "./BrandSelectionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandSelectionView.vue?vue&type=script&setup=true&lang=ts"

import "./BrandSelectionView.vue?vue&type=style&index=0&id=df844f22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df844f22"]])

export default __exports__